const KINGSTON_BG =
  "https://commons.wikimedia.org/wiki/Special:FilePath/Kingston,_ON_-_old_town_hall_and_Martello_tower.jpg?width=2000";

export const Hero = () => {
  const go = (id) => document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section
      id="home"
      className="relative flex min-h-[92vh] items-center justify-center overflow-hidden px-6 pt-24"
      data-testid="hero-section"
    >
      <img
        src={KINGSTON_BG}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover object-top"
        data-testid="hero-background-image"
      />
      <div className="absolute inset-0 bg-[#F4F4F0]/75" aria-hidden="true" />
      <div className="relative z-10 mx-auto max-w-3xl text-center">
        <p
          className="text-xs font-bold uppercase tracking-[0.3em] text-[#111111]"
          data-testid="hero-district"
        >
          Collins-Bayridge · Kingston, Ontario
        </p>
        <h1
          className="mt-8 font-serif text-6xl font-bold leading-[1.05] tracking-tight md:text-8xl"
          data-testid="hero-name"
        >
          Elect
          <br />
          Joel Bruce
        </h1>
        <p
          className="mt-6 font-serif text-2xl font-light italic text-[#16294D] md:text-3xl"
          data-testid="hero-tagline"
        >
          An updated approach, delivered together.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3" data-testid="hero-pills">
          {["Fiscal Responsibility", "Safe Public Spaces", "Transit", "City Maintenance", "Green Space", "Housing Modernization"].map((pill) => (
            <span
              key={pill}
              className="rounded-full border border-[#111111] px-5 py-2 text-xs font-semibold uppercase tracking-[0.2em]"
            >
              {pill}
            </span>
          ))}
        </div>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <button
            onClick={() => go("#about")}
            data-testid="hero-about-button"
            className="border border-[#111111] bg-[#DCDCD6] px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-[#111111] transition-colors duration-300 hover:bg-[#111111] hover:text-[#F4F4F0]"
          >
            About
          </button>
          <button
            onClick={() => go("#priorities")}
            data-testid="hero-priorities-button"
            className="border border-[#111111] bg-[#DCDCD6] px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-[#111111] transition-colors duration-300 hover:bg-[#111111] hover:text-[#F4F4F0]"
          >
            Priorities
          </button>
          <a
            href="https://ca.linkedin.com/in/joel-bruce-mpa-64612831"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-linkedin-link"
            className="border border-[#111111] bg-[#DCDCD6] px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-[#111111] transition-colors duration-300 hover:bg-[#111111] hover:text-[#F4F4F0]"
          >
            LinkedIn
          </a>
          <button
            onClick={() => go("#contact")}
            data-testid="hero-lawnsign-button"
            className="border border-[#111111] bg-[#DCDCD6] px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-[#111111] transition-colors duration-300 hover:bg-[#111111] hover:text-[#F4F4F0]"
          >
            Lawn Signs
          </button>
        </div>
      </div>
    </section>
  );
};
